// Demo mode mock data — realistic data for live demos

export const MOCK_RUNS = [
  {
    id: 'mock-run-1',
    jobUrl: 'https://www.linkedin.com/jobs/view/head-of-sales-techcorp',
    jobTitle: 'Head of Sales',
    company: 'TechCorp',
    status: 'completed',
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    prospectsFound: 45,
    campaignStatus: 'live',
    campaignId: 'demo-campaign-1001',
  },
  {
    id: 'mock-run-2',
    jobUrl: 'https://www.linkedin.com/jobs/view/vp-engineering-startupxyz',
    jobTitle: 'VP of Engineering',
    company: 'StartupXYZ',
    status: 'completed',
    createdAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    prospectsFound: 32,
    campaignStatus: 'live',
    campaignId: 'demo-campaign-1002',
  },
  {
    id: 'mock-run-3',
    jobUrl: 'https://www.linkedin.com/jobs/view/product-manager-scaleup',
    jobTitle: 'Senior Product Manager',
    company: 'ScaleUp Inc',
    status: 'completed',
    createdAt: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    prospectsFound: 28,
    campaignStatus: 'paused',
    campaignId: 'demo-campaign-1003',
  },
  {
    id: 'mock-run-4',
    jobUrl: 'https://www.linkedin.com/jobs/view/marketing-director-growthco',
    jobTitle: 'Marketing Director',
    company: 'GrowthCo',
    status: 'running',
    createdAt: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    prospectsFound: 12,
    campaignStatus: 'draft',
  },
  {
    id: 'mock-run-5',
    jobUrl: 'https://www.linkedin.com/jobs/view/cto-fintech-ventures',
    jobTitle: 'Chief Technology Officer',
    company: 'Fintech Ventures',
    status: 'queued',
    createdAt: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
    prospectsFound: 0,
    campaignStatus: 'draft',
  },
];

export const MOCK_PROSPECTS = [
  {
    id: 'mock-prospect-1',
    run_id: 'mock-run-1',
    organization_id: 'mock-org',
    name: 'Sarah Mitchell',
    title: 'CEO',
    company: 'TechCorp',
    linkedin_url: 'https://linkedin.com/in/sarahmitchell',
    email: 'sarah@techcorp.com',
    stage: 'connected',
    last_activity_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Decision Maker', 'Enterprise'], notes: 'Very responsive, keen interest shown.' },
    phone: '+1 555 0101',
    tags: ['Decision Maker', 'Enterprise'],
    notes: 'Very responsive, keen interest shown.',
    source: 'LinkedIn',
    location: 'San Francisco, CA',
    relevanceScore: 94,
    aiMatchScore: 92,
    matchingReason: 'C-suite decision maker at a scaling SaaS company actively hiring senior sales leadership.',
    messages: [
      {
        type: 'connection-request',
        content: `Hi Sarah,\n\nI came across your profile while researching TechCorp's leadership team — impressive growth you've driven there!\n\nI'm placing a Head of Sales candidate who's delivered $40M+ ARR at similar-stage companies. Would love to connect and share their profile.\n\nBest,\n[Your name]`,
      },
      {
        type: 'follow-up-1',
        content: `Hi Sarah,\n\nJust following up on my earlier note — wanted to make sure it didn't get buried.\n\nOur candidate has 8 years enterprise SaaS sales leadership experience and is actively exploring their next move. Happy to send over a one-pager if that would be useful.\n\nCheers,\n[Your name]`,
      },
      {
        type: 'follow-up-2',
        content: `Hi Sarah,\n\nLast touch from me — if the timing isn't right I completely understand.\n\nIf you'd ever like to see top sales talent for future roles, I'm always happy to help.\n\nWarm regards,\n[Your name]`,
      },
    ],
  },
  {
    id: 'mock-prospect-2',
    run_id: 'mock-run-1',
    organization_id: 'mock-org',
    name: 'James Harrington',
    title: 'COO',
    company: 'TechCorp',
    linkedin_url: 'https://linkedin.com/in/jamesharrington',
    email: 'james@techcorp.com',
    stage: 'conversation_started',
    last_activity_at: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Hot Lead'], notes: 'Asked for a proposal.' },
    phone: '+1 555 0102',
    tags: ['Hot Lead'],
    notes: 'Asked for a proposal.',
    source: 'LinkedIn',
    location: 'New York, NY',
    relevanceScore: 88,
    aiMatchScore: 85,
    matchingReason: 'Operations leader with direct influence over sales hiring decisions.',
    messages: [],
  },
  {
    id: 'mock-prospect-3',
    run_id: 'mock-run-1',
    organization_id: 'mock-org',
    name: 'Emily Chen',
    title: 'VP People',
    company: 'TechCorp',
    linkedin_url: 'https://linkedin.com/in/emilychen',
    email: 'emily@techcorp.com',
    stage: 'qualification',
    last_activity_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Decision Maker'], notes: 'Intro call booked for Friday.' },
    phone: '+1 555 0103',
    tags: ['Decision Maker'],
    notes: 'Intro call booked for Friday.',
    source: 'LinkedIn',
    location: 'Austin, TX',
    relevanceScore: 79,
    aiMatchScore: 77,
    matchingReason: 'Heads up talent acquisition — key stakeholder for senior sales hires.',
    messages: [],
  },
  {
    id: 'mock-prospect-4',
    run_id: 'mock-run-2',
    organization_id: 'mock-org',
    name: 'David Park',
    title: 'CTO',
    company: 'StartupXYZ',
    linkedin_url: 'https://linkedin.com/in/davidpark',
    email: 'david@startupxyz.com',
    stage: 'proposal_sent',
    last_activity_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Hot Lead', 'Decision Maker'], notes: 'Proposal sent, awaiting feedback.' },
    phone: '+1 555 0104',
    tags: ['Hot Lead', 'Decision Maker'],
    notes: 'Proposal sent, awaiting feedback.',
    source: 'LinkedIn',
    location: 'Seattle, WA',
  },
  {
    id: 'mock-prospect-5',
    run_id: 'mock-run-2',
    organization_id: 'mock-org',
    name: 'Rachel Torres',
    title: 'CEO',
    company: 'StartupXYZ',
    linkedin_url: 'https://linkedin.com/in/racheltorres',
    email: 'rachel@startupxyz.com',
    stage: 'signed_mandate',
    last_activity_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Success', 'Decision Maker'], notes: 'Signed! Placement in progress.' },
    phone: '+1 555 0105',
    tags: ['Success', 'Decision Maker'],
    notes: 'Signed! Placement in progress.',
    source: 'LinkedIn',
    location: 'Boston, MA',
  },
  {
    id: 'mock-prospect-6',
    run_id: 'mock-run-3',
    organization_id: 'mock-org',
    name: 'Marcus Johnson',
    title: 'Founder',
    company: 'ScaleUp Inc',
    linkedin_url: 'https://linkedin.com/in/marcusjohnson',
    email: 'marcus@scaleup.com',
    stage: 'invite_sent',
    last_activity_at: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Startup'], notes: '' },
    phone: '',
    tags: ['Startup'],
    notes: '',
    source: 'LinkedIn',
    location: 'Chicago, IL',
  },
  {
    id: 'mock-prospect-7',
    run_id: 'mock-run-1',
    organization_id: 'mock-org',
    name: 'Olivia Bennett',
    title: 'Chief Revenue Officer',
    company: 'TechCorp',
    linkedin_url: 'https://linkedin.com/in/oliviabennett',
    email: 'olivia@techcorp.com',
    stage: 'lost',
    last_activity_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Cold'], notes: 'Not interested at this time.' },
    phone: '+1 555 0107',
    tags: ['Cold'],
    notes: 'Not interested at this time.',
    source: 'LinkedIn',
    location: 'Los Angeles, CA',
  },
  {
    id: 'mock-prospect-8',
    run_id: 'mock-run-2',
    organization_id: 'mock-org',
    name: 'Nathan Reid',
    title: 'VP Sales',
    company: 'GrowthCo',
    linkedin_url: 'https://linkedin.com/in/nathanreid',
    email: 'nathan@growthco.com',
    stage: 'conversation_started',
    last_activity_at: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Hot Lead'], notes: 'Replied quickly, very interested in the role.' },
    phone: '+1 555 0108',
    tags: ['Hot Lead'],
    notes: 'Replied quickly, very interested in the role.',
    source: 'LinkedIn',
    location: 'Denver, CO',
  },
  {
    id: 'mock-prospect-9',
    run_id: 'mock-run-3',
    organization_id: 'mock-org',
    name: 'Priya Sharma',
    title: 'Head of Product',
    company: 'ScaleUp Inc',
    linkedin_url: 'https://linkedin.com/in/priyasharma',
    email: 'priya@scaleup.com',
    stage: 'conversation_started',
    last_activity_at: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Decision Maker'], notes: 'Engaged well, wants to know more.' },
    phone: '+1 555 0109',
    tags: ['Decision Maker'],
    notes: 'Engaged well, wants to know more.',
    source: 'LinkedIn',
    location: 'Miami, FL',
  },
  {
    id: 'mock-prospect-10',
    run_id: 'mock-run-1',
    organization_id: 'mock-org',
    name: 'Tom Walters',
    title: 'CEO',
    company: 'Nexus Labs',
    linkedin_url: 'https://linkedin.com/in/tomwalters',
    email: 'tom@nexuslabs.io',
    stage: 'qualification',
    last_activity_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Enterprise', 'Hot Lead'], notes: 'Discovery call scheduled for Monday.' },
    phone: '+1 555 0110',
    tags: ['Enterprise', 'Hot Lead'],
    notes: 'Discovery call scheduled for Monday.',
    source: 'LinkedIn',
    location: 'Portland, OR',
  },
  {
    id: 'mock-prospect-11',
    run_id: 'mock-run-2',
    organization_id: 'mock-org',
    name: 'Chloe Martin',
    title: 'COO',
    company: 'Fintech Ventures',
    linkedin_url: 'https://linkedin.com/in/chloemartin',
    email: 'chloe@fintechventures.com',
    stage: 'qualification',
    last_activity_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Decision Maker'], notes: 'Qualified well. Strong fit for VP Engineering search.' },
    phone: '+1 555 0111',
    tags: ['Decision Maker'],
    notes: 'Qualified well. Strong fit for VP Engineering search.',
    source: 'LinkedIn',
    location: 'Houston, TX',
  },
  {
    id: 'mock-prospect-12',
    run_id: 'mock-run-3',
    organization_id: 'mock-org',
    name: 'Leo Kim',
    title: 'Founder & CEO',
    company: 'CloudBase',
    linkedin_url: 'https://linkedin.com/in/leokim',
    email: 'leo@cloudbase.dev',
    stage: 'proposal_sent',
    last_activity_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Hot Lead', 'Startup'], notes: 'Reviewed proposal, wants a call this week.' },
    phone: '+1 555 0112',
    tags: ['Hot Lead', 'Startup'],
    notes: 'Reviewed proposal, wants a call this week.',
    source: 'LinkedIn',
    location: 'Atlanta, GA',
  },
  {
    id: 'mock-prospect-13',
    run_id: 'mock-run-1',
    organization_id: 'mock-org',
    name: 'Sophie Laurent',
    title: 'VP Marketing',
    company: 'BrightEdge',
    linkedin_url: 'https://linkedin.com/in/sophielaurent',
    email: 'sophie@brightedge.com',
    stage: 'signed_mandate',
    last_activity_at: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Success'], notes: 'Mandate signed. Starting candidate search immediately.' },
    phone: '+1 555 0113',
    tags: ['Success'],
    notes: 'Mandate signed. Starting candidate search immediately.',
    source: 'LinkedIn',
    location: 'Philadelphia, PA',
  },
  {
    id: 'mock-prospect-14',
    run_id: 'mock-run-4',
    organization_id: 'mock-org',
    name: 'Aiden Clarke',
    title: 'CTO',
    company: 'DataStream',
    linkedin_url: 'https://linkedin.com/in/aidenclarke',
    email: 'aiden@datastream.ai',
    stage: 'lost',
    last_activity_at: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    metadata: { tags: ['Cold'], notes: 'Hired internally. Keep warm for future roles.' },
    phone: '+1 555 0114',
    tags: ['Cold'],
    notes: 'Hired internally. Keep warm for future roles.',
    source: 'LinkedIn',
    location: 'San Diego, CA',
  },
];

export const MOCK_PIPELINE = {
  prospects: MOCK_PROSPECTS.filter(p => p.stage !== 'not_started'),
  stageCounts: {
    invite_sent: 1,
    connected: 1,
    conversation_started: 3,
    qualification: 3,
    proposal_sent: 2,
    signed_mandate: 2,
    lost: 2,
  },
};

export const MOCK_TASKS = [
  {
    id: 'mock-task-1',
    title: 'Follow up with Sarah Mitchell',
    description: 'She showed strong interest — send a follow-up message.',
    priority: 'high',
    status: 'pending',
    due_date: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString(),
    prospect_id: 'mock-prospect-1',
    created_at: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-task-2',
    title: 'Send proposal to David Park',
    description: 'Prepare and send the placement proposal for VP Engineering role.',
    priority: 'high',
    status: 'pending',
    due_date: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(),
    prospect_id: 'mock-prospect-4',
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-task-3',
    title: 'Schedule intro call with Emily Chen',
    description: 'Confirm Friday call details and send calendar invite.',
    priority: 'medium',
    status: 'pending',
    due_date: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString(),
    prospect_id: 'mock-prospect-3',
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-task-4',
    title: 'Finalise mandate with Rachel Torres',
    description: 'Review signed mandate and kick off placement process.',
    priority: 'high',
    status: 'completed',
    due_date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    prospect_id: 'mock-prospect-5',
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-task-5',
    title: 'Call Nathan Reid to discuss role brief',
    description: 'Walk him through the Head of Sales JD and confirm mutual interest.',
    priority: 'high',
    status: 'pending',
    due_date: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString(),
    prospect_id: 'mock-prospect-8',
    created_at: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-task-6',
    title: 'Send shortlist to Chloe Martin',
    description: 'Compile top 3 candidates and send across before EOD.',
    priority: 'high',
    status: 'pending',
    due_date: new Date(Date.now() + 0.5 * 24 * 60 * 60 * 1000).toISOString(),
    prospect_id: 'mock-prospect-11',
    created_at: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-task-7',
    title: 'Draft engagement letter for Sophie Laurent',
    description: 'Prepare the standard mandate agreement and send for review.',
    priority: 'medium',
    status: 'pending',
    due_date: new Date(Date.now() + 4 * 24 * 60 * 60 * 1000).toISOString(),
    prospect_id: 'mock-prospect-13',
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-task-8',
    title: 'Check in with Leo Kim post-proposal',
    description: 'He said he would review over the weekend — follow up today.',
    priority: 'medium',
    status: 'pending',
    due_date: new Date(Date.now() + 0 * 24 * 60 * 60 * 1000).toISOString(),
    prospect_id: 'mock-prospect-12',
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-task-9',
    title: 'Book discovery call with Tom Walters',
    description: 'Confirm availability and send calendar invite for Monday morning.',
    priority: 'medium',
    status: 'pending',
    due_date: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(),
    prospect_id: 'mock-prospect-10',
    created_at: new Date(Date.now() - 18 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-task-10',
    title: 'Update CRM notes for Priya Sharma',
    description: 'Log conversation summary and next steps from yesterday\'s call.',
    priority: 'low',
    status: 'completed',
    due_date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    prospect_id: 'mock-prospect-9',
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-task-11',
    title: 'Send HeyReach campaign report to team',
    description: 'Compile weekly outreach stats and share in the team channel.',
    priority: 'low',
    status: 'pending',
    due_date: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(),
    prospect_id: null,
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-task-12',
    title: 'Review and approve new LinkedIn message templates',
    description: 'Check the A/B test variants before the next campaign launch.',
    priority: 'medium',
    status: 'completed',
    due_date: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    prospect_id: null,
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
  },
];

export const MOCK_CONTACTS = MOCK_PROSPECTS.filter(p => p.stage !== 'not_started');

export const MOCK_JOBS = [
  {
    id: 'mock-job-1',
    title: 'Head of Sales',
    company: 'TechCorp',
    status: 'open',
    assignedRecruiter: 'Sarah Johnson',
    startDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
    daysOpen: 14,
    source: 'LinkedIn Outreach',
    location: 'San Francisco, CA',
    feeType: '20% of first year salary',
    estimatedValue: '$42,000',
    dealId: 'mock-deal-1',
    jobPostUrl: 'https://www.linkedin.com/jobs/view/head-of-sales-techcorp',
  },
  {
    id: 'mock-job-2',
    title: 'VP of Engineering',
    company: 'StartupXYZ',
    status: 'open',
    assignedRecruiter: 'Sarah Johnson',
    startDate: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    daysOpen: 10,
    source: 'LinkedIn Outreach',
    location: 'New York, NY',
    feeType: '20% of first year salary',
    estimatedValue: '$56,000',
    dealId: 'mock-deal-2',
    jobPostUrl: 'https://www.linkedin.com/jobs/view/vp-engineering-startupxyz',
  },
  {
    id: 'mock-job-3',
    title: 'Senior Product Manager',
    company: 'ScaleUp Inc',
    status: 'on_hold',
    assignedRecruiter: 'Mike Peters',
    startDate: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString(),
    daysOpen: 21,
    source: 'Referral',
    location: 'Austin, TX',
    feeType: '18% of first year salary',
    estimatedValue: '$27,000',
    dealId: 'mock-deal-3',
    jobPostUrl: '',
  },
  {
    id: 'mock-job-4',
    title: 'Marketing Director',
    company: 'BrightEdge',
    status: 'closed_filled',
    assignedRecruiter: 'Sarah Johnson',
    startDate: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString(),
    daysOpen: 38,
    source: 'LinkedIn Outreach',
    location: 'Philadelphia, PA',
    feeType: '20% of first year salary',
    estimatedValue: '$34,000',
    dealId: 'mock-deal-4',
    jobPostUrl: '',
  },
  {
    id: 'mock-job-5',
    title: 'Chief Technology Officer',
    company: 'Fintech Ventures',
    status: 'open',
    assignedRecruiter: 'Mike Peters',
    startDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    daysOpen: 5,
    source: 'LinkedIn Outreach',
    location: 'Houston, TX',
    feeType: '22% of first year salary',
    estimatedValue: '$70,000',
    dealId: 'mock-deal-5',
    jobPostUrl: 'https://www.linkedin.com/jobs/view/cto-fintech-ventures',
  },
];

export const MOCK_MEMBERS = [
  {
    id: 'mock-member-1',
    name: 'Alex Rivera',
    email: 'alex@acmerecruitment.com',
    role: 'admin' as const,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=alex-rivera',
    joinedAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-member-2',
    name: 'Jordan Blake',
    email: 'jordan@acmerecruitment.com',
    role: 'member' as const,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=jordan-blake',
    joinedAt: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-member-3',
    name: 'Casey Morgan',
    email: 'casey@acmerecruitment.com',
    role: 'member' as const,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=casey-morgan',
    joinedAt: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-member-4',
    name: 'Taylor Kim',
    email: 'taylor@acmerecruitment.com',
    role: 'member' as const,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=taylor-kim',
    joinedAt: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'mock-member-5',
    name: 'Sam Chen',
    email: 'sam@acmerecruitment.com',
    role: 'member' as const,
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=sam-chen',
    joinedAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
  },
];
